<template>
    <b-form-group label-class="mb-0 label-title" :label="item.title" label-for="long-text__form-item">
        <b-textarea :class="{ 'saving': saving, 'saved': saved }" id="free-text__form-item" v-model="item.value" :rows="6" @focus="showHelp" @blur="hideHelp" :disabled="item.disabled" @keydown="valueChanged"/>
        <span class="wordcount">{{wordCount}}</span>
        <p class="help-text mt-2" v-html="helpText"></p>
    </b-form-group>
</template>

<script>
    import FormItem from './FormItem'
    import { debounce } from 'lodash';
    import { EventBus } from "../../event-bus";

    export default {
        name: "LongTextFormItem",
        extends: FormItem,
        data() {
            return {
                saving: false,
                saved: false,
            }
        },
        created() {
            // Create the debounced function once during component creation
             this.debouncedSave = debounce(() => {
                this.saved = true;
                this.saving = false;
                setTimeout(() => {
                    this.saved = false;
                },1000);
            }, 1000);
        },
        methods: {
            valueChanged(event) {
                // Set saving state and reset saved state
                this.saving = true;
                this.saved = false;
                EventBus.$emit('form-saving-started');
                this.debouncedSave();
            }
        },
        computed: {
            wordCount: function() {
                let wc = this.$wordCount(this.item.value);
                if (wc === 0) return '';

                let suffix = wc !== 1 ? ' words' : ' word';
                return '' + wc + suffix;
            }
        }
    }
</script>

<style scoped>
    .wordcount {
        font-size: 12px;
        text-transform: uppercase;
    }
    .help-text {
        font-size: 12px;
    }
</style>